import { SVGProps, useId } from "react";

export default function MessageYouIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 19, width = 20, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="16" height="16" rx="8" fill={`url(#you_bg_${id})`} />
      <g filter={`url(#you_inner_shadow_${id})`}>
        <g clipPath={`url(#you_clip_${id})`}>
          <rect width="16" height="16" rx="8" fill={`url(#you_avatar_bg_${id})`} />
          <g filter={`url(#you_body_filter_${id})`}>
            <ellipse
              cx="8.00156"
              cy="15.2"
              rx="6.4"
              ry="4.8"
              fill={`url(#you_body_fill_${id})`}
              shapeRendering="crispEdges"
            />
            <path
              d="M8.00195 10.733C9.70396 10.7331 11.2321 11.2516 12.3271 12.0729C13.422 12.8941 14.0683 14.0029 14.0684 15.1998C14.0684 16.3969 13.4222 17.5065 12.3271 18.3278C11.2321 19.149 9.70392 19.6665 8.00195 19.6666C6.29979 19.6666 4.77091 19.1491 3.67578 18.3278C2.58078 17.5065 1.93457 16.3969 1.93457 15.1998C1.93464 14.003 2.58101 12.8941 3.67578 12.0729C4.77091 11.2515 6.29979 10.733 8.00195 10.733Z"
              stroke={`url(#you_body_stroke_${id})`}
              strokeWidth="0.666667"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter={`url(#you_head_filter_${id})`}>
            <circle
              cx="8.00078"
              cy="6.40001"
              r="3.2"
              fill={`url(#you_head_fill_${id})`}
              shapeRendering="crispEdges"
            />
            <circle
              cx="8.00078"
              cy="6.40001"
              r="2.86667"
              stroke={`url(#you_head_stroke_${id})`}
              strokeWidth="0.666667"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
      </g>
      <g filter={`url(#you_status_filter_${id})`}>
        <path
          d="M17.168 12C17.168 13.3807 16.0487 14.5 14.668 14.5C13.2873 14.5 12.168 13.3807 12.168 12C12.168 10.6193 13.2873 9.5 14.668 9.5C16.0487 9.5 17.168 10.6193 17.168 12Z"
          fill="white"
        />
        <path
          d="M16.168 12C16.168 12.8284 15.4964 13.5 14.668 13.5C13.8395 13.5 13.168 12.8284 13.168 12C13.168 11.1716 13.8395 10.5 14.668 10.5C15.4964 10.5 16.168 11.1716 16.168 12Z"
          fill="#38C793"
        />
      </g>
      <defs>
        <filter
          id={`you_inner_shadow_${id}`}
          x="0"
          y="-5.33333"
          width="16"
          height="21.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-5.33333" />
          <feGaussianBlur stdDeviation="5.33333" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.431292 0 0 0 0 0.248526 0 0 0 0 0.951474 0 0 0 0.24 0"
          />
          <feBlend mode="normal" in2="shape" result={`effect1_innerShadow_${id}`} />
        </filter>
        <filter
          id={`you_body_filter_${id}`}
          x="-1.0651"
          y="5.06669"
          width="18.1341"
          height="20.2666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.66667" />
          <feGaussianBlur stdDeviation="1.33333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.431292 0 0 0 0 0.248526 0 0 0 0 0.951474 0 0 0 0.24 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result={`effect1_dropShadow_body_${id}`} />
          <feBlend mode="normal" in="SourceGraphic" in2={`effect1_dropShadow_body_${id}`} result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-5.33333" />
          <feGaussianBlur stdDeviation="2.66667" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result={`effect2_innerShadow_body_${id}`} />
        </filter>
        <filter
          id={`you_head_filter_${id}`}
          x="2.13411"
          y="-2.13332"
          width="11.7318"
          height="17.0667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.66667" />
          <feGaussianBlur stdDeviation="1.33333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.431292 0 0 0 0 0.248526 0 0 0 0 0.951474 0 0 0 0.24 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result={`effect1_dropShadow_head_${id}`} />
          <feBlend mode="normal" in="SourceGraphic" in2={`effect1_dropShadow_head_${id}`} result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-5.33333" />
          <feGaussianBlur stdDeviation="2.66667" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result={`effect2_innerShadow_head_${id}`} />
        </filter>
        <filter
          id={`you_status_filter_${id}`}
          x="8.0013"
          y="6.66667"
          width="13.3333"
          height="13.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.33333" />
          <feGaussianBlur stdDeviation="1.33333" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result={`effect1_dropShadow_status_${id}`} />
          <feBlend mode="normal" in="SourceGraphic" in2={`effect1_dropShadow_status_${id}`} result="shape" />
        </filter>
        <linearGradient id={`you_bg_${id}`} x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient id={`you_avatar_bg_${id}`} x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <radialGradient
          id={`you_body_fill_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.00156 10.4) rotate(90) scale(9.6 12.8)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`you_body_stroke_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.00156 10.4) rotate(90) scale(9.6 12.8)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`you_head_fill_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.00078 3.20001) rotate(90) scale(6.4)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`you_head_stroke_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.00078 3.20001) rotate(90) scale(6.4)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id={`you_clip_${id}`}>
          <rect width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
